export function formatNumber(num: number): string {
  if (num >= 1_000_000) {
    const millions = (num / 1_000_000).toFixed(1);
    return `${millions.replace('.0', '')}M`;
  }
  if (num >= 10_000) {
    const thousands = (num / 1_000).toFixed(1);
    return `${thousands.replace('.0', '')}K`;
  }
  return num?.toLocaleString();
}

export function formatCompactPercent(value: number) {
  return `${value.toFixed(1)}%`;
}
